import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

// Route protégée pour les utilisateurs authentifiés
export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div className="flex justify-center items-center h-screen">Chargement...</div>;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  return children;
};

// Route protégée pour les agriculteurs
export const FarmerRoute = ({ children }) => {
  const { isAuthenticated, isFarmer, loading } = useAuth();
  
  if (loading) {
    return <div className="flex justify-center items-center h-screen">Chargement...</div>;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  if (!isFarmer) {
    return <Navigate to="/unauthorized" />;
  }
  
  return children;
};

// Page d'accès non autorisé
export const Unauthorized = () => {
  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-lg mt-10">
      <h2 className="text-2xl font-bold text-center text-red-700 mb-6">Accès non autorisé</h2>
      <p className="text-gray-700 mb-4">
        Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
      </p>
      <div className="flex justify-center">
        <button
          onClick={() => window.history.back()}
          className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-6 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
        >
          Retour
        </button>
      </div>
    </div>
  );
};